<section id="home" class="slider_area">
    <div id="carouselThree" class="carousel slide" data-ride="carousel">
        <ol class="carousel-indicators">
            <li data-target="#carouselThree" data-slide-to="0" class="active"></li>
        </ol>
        <div class="carousel-inner">
            <div class="carousel-item active">
                <div class="container">
                    <div class="row align-items-center flex-container">
                        <div class="col-lg-7">
                            <div class="slider-content">
                                <h1 class="title">{{'PERSONALIZED_SOLUTION.TITLE' | translate }}</h1>
                                <p class="text white">{{'PERSONALIZED_SOLUTION.TEXT' | translate }}</p>
                                <div class="slider-buttons">
                                    <div class="button-wrap">
                                        <a href="https://admin.propero.io/" target="_blank" class="btn primary-btn">
                                            Propero Assistant
                                        </a>
                                        <span i18n="@@mainSubtitleAdditionalText" class="btn-subtext">
                                            {{ 'HOME.MAIN_SUBTITLE_ADDITIONAL_TEXT' | translate }}
                                        </span>
                                    </div>

                                    <div class="button-wrap">
                                        <a routerLink="/solution-personalised" class="btn secondary-btn"
                                            i18n="@@mainPersonalizedOffer">
                                            {{ 'HOME.MAIN_PERSONALIZED_OFFER' | translate }}
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-5">
                            <div class="slider-image">
                                <img src="assets/images/slider/2.png" alt="Hero">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <a class="carousel-control-prev" href="#carouselThree" role="button" data-slide="prev">
            <i class="lni lni-arrow-left"></i>
        </a>
        <a class="carousel-control-next" href="#carouselThree" role="button" data-slide="next">
            <i class="lni lni-arrow-right"></i>
        </a>
    </div>
</section>

<section class="features-area white-area">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-lg-12 col-md-2">
                <div class="section-title text-center">
                    <h3 class="title">{{'PERSONALIZED_SOLUTION.FEATURES_TITLE' | translate }}</h3>
                    <p class="text">{{'PERSONALIZED_SOLUTION.FEATURES_TEXT' | translate }}</p>
                </div>
            </div>
        </div>
        <div class="row compare-area-table justify-content-center">
            <div class="col-lg-5 col-md-7 col-sm-9">
                <div class="single-features mt-40">
                    <div class="justify-content-between">
                        <div class="icon center">
                            <img src="assets/images/marketing/S-Personalized-Cloud.svg" alt="Shape">
                        </div>
                        <h4 class="features-title center mt-4">
                            {{'PERSONALIZED_SOLUTION.SOLUTION1_TITLE' | translate }}</h4>
                    </div>
                    <div class="features-content">
                        <p class="tooltip-text-content">
                            <span> {{'PERSONALIZED_SOLUTION.SOLUTION1_SUBTITLE' | translate }}</span>
                        </p>
                    </div>
                </div>
            </div>

            <div class="col-lg-5 col-md-7 col-sm-9">
                <div class="single-features mt-40">
                    <div class="justify-content-between">
                        <div class="icon center">
                            <img src="assets/images/marketing/S-Personalized-WhiteLabel-Logo.svg" alt="Shape">
                        </div>
                        <h4 class="features-title center mt-4">
                            {{'PERSONALIZED_SOLUTION.SOLUTION2_TITLE' | translate }}</h4>
                    </div>
                    <div class="features-content">
                        <p class="tooltip-text-content">
                            {{'PERSONALIZED_SOLUTION.SOLUTION2_SUBTITLE' | translate }}
                        </p>
                    </div>
                </div>
            </div>

            <div class="col-lg-5 col-md-7 col-sm-9">
                <div class="single-features mt-40">
                    <div class="justify-content-between">
                        <div class="icon center">
                            <img src="assets/images/marketing/S-Personalized-Db-Cloud.svg" alt="Shape">
                        </div>
                        <h4 class="features-title center mt-4">
                            {{'PERSONALIZED_SOLUTION.SOLUTION3_TITLE' | translate }}</h4>
                    </div>
                    <div class="features-content">
                        <p class="tooltip-text-content">
                            {{'PERSONALIZED_SOLUTION.SOLUTION3_SUBTITLE' | translate }}
                        </p>
                    </div>
                </div>
            </div>

            <div class="col-lg-5 col-md-7 col-sm-9">
                <div class="single-features mt-40">
                    <div class="justify-content-between">
                        <div class="icon center">
                            <img src="assets/images/marketing/S-Personalized-Db.svg" alt="Shape">
                        </div>
                        <h4 class="features-title center mt-4">
                            {{'PERSONALIZED_SOLUTION.SOLUTION4_TITLE' | translate }}</h4>
                    </div>
                    <div class="features-content">
                        <p class="tooltip-text-content">
                            {{'PERSONALIZED_SOLUTION.SOLUTION4_SUBTITLE' | translate }}
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <br />
        <div class="section-footer center mt-40">
            <ul class="slider-btn rounded-buttons">
                <li>
                    <a class="features-btn" href="/solution-personalised/#contact">
                        {{'PERSONALIZED_SOLUTION.WANT_DETAILS' | translate }}
                    </a>
                </li>
            </ul>
        </div>
    </div>
</section>

<section id="contact" class="contact-area grey-area">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-lg-10 col-md-10">
                <div class="section-title text-center pb-30">
                    <h3 class="title">{{ 'HOME.SECTION_CONTACTUS_TITLE' | translate }}</h3>
                    <p class="text">{{ 'HOME.SECTION_CONTACTUS_TEXT' | translate }}</p>
                </div>
            </div>
        </div>

        <!-- <div class="row">
            <div class="col-lg-12">
                <div class="contact-map">
                    <iframe 
                        src="https://maps.google.com/maps?q=brasov&t=&z=13&ie=UTF8&iwloc=&output=embed" 
                        allowfullscreen>
                    </iframe>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-lg-4 col-md-6">
                <div class="single-contact-info contact-color-1">
                    <div class="contact-info-icon">
                        <i class="lni lni-map-marker"></i>
                    </div>
                    <div class="contact-info-content">
                        <p class="text">Str. Calea București nr. 20<br>Sc B Ap 4<br>Brașov, Romania</p>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="single-contact-info contact-color-2">
                    <div class="contact-info-icon">
                        <i class="lni lni-envelope"></i>
                    </div>
                    <div class="contact-info-content">
                        <p class="text">contact@propero.io</p>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="single-contact-info contact-color-3">
                    <div class="contact-info-icon">
                        <i class="lni lni-phone"></i>
                    </div>
                    <div class="contact-info-content">
                        <p class="text">(+4) 0743 366 266</p>
                    </div>
                </div>
            </div>
        </div> -->

        <div class="row justify-content-center">
            <div class="col-lg-10">
                <div class="contact-wrapper">
                    <h4 class="contact-title">
                        <i class="lni lni-envelope"></i>
                        {{ 'HOME.TEXT_MESSAGE' | translate }}
                    </h4>
                    <form #contactForm="ngForm" (ngSubmit)="send()">
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-input">
                                    <label>{{ 'PERSONALIZED_SOLUTION.NAME' | translate }}</label>
                                    <div class="input-items">
                                        <input type="text" name="name" placeholder="{{ 'PERSONALIZED_SOLUTION.NAME' | translate }}"
                                            [(ngModel)]="contactItem.subject" required>
                                        <i class="lni lni-user"></i>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-input">
                                    <label>{{ 'PERSONALIZED_SOLUTION.EMAIL' | translate }}</label>
                                    <div class="input-items">
                                        <input type="email" name="email" placeholder="{{ 'PERSONALIZED_SOLUTION.EMAIL' | translate }}"
                                            [(ngModel)]="contactItem.email" required email>
                                        <i class="lni lni-envelope"></i>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="form-input">
                                    <label>{{ 'PERSONALIZED_SOLUTION.MESSAGE' | translate }}</label>
                                    <div class="input-items textarea">
                                        <textarea name="message" placeholder="{{ 'PERSONALIZED_SOLUTION.MESSAGE' | translate }}"
                                            [(ngModel)]="contactItem.content" required></textarea>
                                        <i class="lni lni-pencil-alt"></i>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="text-center">
                                    <button 
                                        type="submit"
                                        class="features-btn" 
                                        [disabled]="contactForm.invalid || isLoading"
                                        [ngClass]="{'loading': isLoading}"
                                    >
                                        <span *ngIf="!isLoading">{{ 'HOME.SEND' | translate }}</span>
                                        <span *ngIf="isLoading">{{ 'HOME.SENDING' | translate }}</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</section>